import React, { useState, useEffect } from 'react'
import Header from './../components/Header'
import Footer from './../components/Footer'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { IoIosArrowForward } from 'react-icons/io'
import { messageClear } from '../store/reducers/orderReducer'
// import Stripe from '../components/Stripe'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'

const Payment = () => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const { order, errorMessage, successMessage } = useSelector(
    (state) => state.order
  )
  const {
    state: { price, items, orderId },
  } = useLocation()
  const [paymentMethod, setPaymentMethod] = useState('Cash on delivery')

  const payment_method_update = (paymentMethod) => {
    // dispatch(order_confirm({ orderId, paymentMethod: paymentMethod }))
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      dispatch(messageClear())
      navigate('/')
    }
    if (errorMessage) {
      toast.error(errorMessage)
      dispatch(messageClear())
    }
  }, [successMessage, errorMessage])

  const fibLogo = '../../../images/payment/fib.png'
  const fibQr = '../../../images/payment/fibQR.jpg'
  const codLogo = '../../../images/payment/cod.jpg'

  return (
    <div>
      <Header />
      <section className=" mt-5 bg-cover bg-no-repeat relative bg-left">
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[65%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white"></div>
          </div>
        </div>
      </section>

      <section>
        <div className="bg-slate-100 py-5 mb-2">
          <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex justify-start items-center text-md text-slate-600 w-full">
              <Link to="/">{t('home.home')}</Link>
              <span className="pt-1">
                <IoIosArrowForward />
              </span>
              <span className="text-[#B65278]">{t('home.payment')} </span>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-white">
        <div className="w-[70%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-8 sm:px-0 ">
          <div className="flex  md:flex-col-reverse gap-4">
            <div className="w-full md:w-full ">
              <div className="w-full px-2 md:px-0 ">
                <div className="w-full sm:w-full">
                  <span className="pt-1 text-sm font-bold">
                    {' '}
                    {t('home.payment_type')}
                  </span>
                </div>
                <div className="w-[30%] sm:w-full gap-4">
                  <div className="py-4">
                    <label
                      className={`flex items-center gap-2 border cursor-pointer py-2 px-4 rounded ${
                        paymentMethod === 'FIB'
                          ? 'bg-white shadow-md'
                          : 'bg-slate-100'
                      }`}
                    >
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="FIB"
                        // disabled
                        checked={paymentMethod === 'FIB'}
                        onChange={() => setPaymentMethod('FIB')}
                        className="cursor-pointer"
                      />
                      <img src={fibLogo} alt="FIB" className="w-6 h-6" />
                      <span className="text-slate-600">FIB</span>
                    </label>
                  </div>
                  <div className="w-full sm:w-full flex items-center justify-center">
                    {paymentMethod === 'FIB' && (
                      <div className="w-full sm:w-full  p-4">
                        <img src={fibQr} alt="FIB" className="w-40 h-60" />
                        <span>{t('home.scan_barcode')}</span>
                        {/* <Stripe orderId={orderId} price={price} /> */}
                      </div>
                    )}
                  </div>
                  <div>
                    <label
                      className={`flex items-center gap-2 border cursor-pointer py-2 px-4 rounded ${
                        paymentMethod === 'Cash on delivery'
                          ? 'bg-white shadow-md'
                          : 'bg-slate-100'
                      }`}
                    >
                      <input
                        type="radio"
                        name="paymentMethod"
                        value="Cash on delivery"
                        checked={paymentMethod === 'Cash on delivery'}
                        onChange={() => setPaymentMethod('Cash on delivery')}
                        className="cursor-pointer"
                      />
                      <img src={codLogo} alt="COD" className="w-6 h-6" />
                      <span className="text-slate-600">
                        {t('home.cash_on_delivery')}
                      </span>
                    </label>
                  </div>

                  <div>
                    {paymentMethod === 'Cash on delivery' && (
                      <div className="w-full sm:w-full  pt-4">
                        <button
                          onClick={() => payment_method_update(paymentMethod)}
                          className="w-full px-10 py-[8px] rounded-sm hover:shadow-green-500/20 hover:shadow-lg bg-[#1b7837] text-white"
                        >
                          <span className="pt-1 text-md">
                            {' '}
                            {t('orderS.submit')}
                          </span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="w-5/12 md:w-full">
              <div className="pl-2 md:pl-0 md:mb-0">
                <div className="bg-white shadow p-5 text-slate-600 flex flex-col gap-3">
                  <h2 className="font-bold text-sm">
                    {t('orderS.order_summary')}
                  </h2>
                  {/* <div className="flex justify-between items-center">
                    <span>Items and Shipping Fee Included </span>
                    <span>{price}{' '}
                    {t('products.currency')} </span>
                  </div> */}
                  <div className="flex justify-between items-center text-sm font-semibold">
                    <span>{t('orderS.total_price')}</span>
                    <span className="text-lg text-green-600">
                      {price} {t('products.currency')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Payment
